
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Innovacabs() {



    const cardData =
    {
        keyword: ' Innova Cabs',
        heading: 'Prince Cabs: Innova Cabs',
        headingDescription: 'Prince Cabs provides comfortable and spacious Innova Cabs, ideal for family travel, group outings, corporate trips, airport transfers, and outstation journeys. Our well-maintained Innova and Innova Crysta vehicles are equipped with modern amenities to ensure a safe and enjoyable ride. With professional chauffeurs, transparent pricing, and on-time service, we make your travel completely hassle-free. Experience reliability, comfort, and affordability with Prince Cabs’ trusted Innova cab services in Pune and beyond.',

        top: 'Top Places to Visit in Pune Outstation with Prince Cabs',

"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar, located 120 km from Pune, is one of Maharashtra’s most loved hill stations. Famous for its strawberry farms, boating at Venna Lake, and viewpoints like Arthur’s Seat and Wilson Point, it offers a refreshing escape from city life. The ancient Mahabaleshwar Temple adds spiritual significance. During monsoon, waterfalls and misty valleys make it magical. Winters bring a cozy holiday feel. It is among the top weekend getaways from Pune."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 65 km from Pune, Lonavala and Khandala are twin hill stations in the Sahyadris, ideal for quick trips. They are known for attractions like Tiger’s Leap, Bhushi Dam, Karla & Bhaja Caves, and Rajmachi Fort. Monsoon transforms the valleys into green carpets dotted with waterfalls. Adventure lovers enjoy trekking, camping, and Pawna Lake activities. Street food like hot vada pav and chikki adds local flavor. They remain Pune’s favorite weekend getaways."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa, a planned hill city about 60 km from Pune, is inspired by Italian architecture and built around a serene lake. The Lakeside Promenade is lined with cafés, resorts, and vibrant streets. Boating, cycling, and adventure sports make it ideal for families and couples. The cityscape looks particularly scenic in monsoon. Wellness retreats here attract urban travelers. Lavasa blends modernity, leisure, and natural beauty."
  },
  {
    "title": "Panchgani",
    "description": "Located 100 km from Pune, Panchgani is a peaceful hill station surrounded by five hills. Table Land, Asia’s second-largest volcanic plateau, is its highlight. Strawberry farms, viewpoints, and boarding school heritage add charm. Paragliding and trekking attract adventure seekers. Its calm weather makes it a year-round destination. Panchgani is often visited along with Mahabaleshwar for a complete hill retreat."
  },
  {
    "title": "Matheran",
    "description": "Matheran, about 120 km from Pune, is Asia’s only automobile-free hill station. Known for its red-soil trails, toy train, and 30+ viewpoints like Panorama Point and Charlotte Lake, it is perfect for nature lovers. Trekkers enjoy its forested routes, especially in monsoon. The fresh air and eco-friendly vibe make it unique. Families and couples love its peaceful charm. It offers a vintage hill-station experience."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug, around 140 km from Pune, is a coastal getaway famous for its beaches and sea forts. Popular spots include Alibaug Beach, Varsoli Beach, and Kolaba Fort. Adventure lovers enjoy water sports at Nagaon Beach. The town is also famous for fresh seafood and beach homestays. Sunset views over the Arabian Sea are spectacular. Alibaug is the perfect mix of history, leisure, and sea breeze."
  },
  {
    "title": "Tarkarli",
    "description": "Tarkarli, in Sindhudurg district, is about 385 km from Pune and worth the long drive for its pristine beaches. Known as Maharashtra’s scuba diving capital, it offers snorkeling, parasailing, and dolphin-spotting. The white sands and clear waters rival Goa’s charm. Homestays near the beach showcase Konkani hospitality. Sindhudurg Fort nearby adds historical value. It is a paradise for water sports and nature lovers."
  },
  {
    "title": "Shirdi",
    "description": "Located 185 km from Pune, Shirdi is one of India’s most important pilgrimage centers dedicated to Shri Sai Baba. Devotees visit the Samadhi Mandir, Dwarkamai, and Chavadi for blessings. The daily aartis attract lakhs of pilgrims. The town is well connected by road, making it a convenient outstation trip. Many combine Shirdi with Shani Shingnapur for a spiritual circuit. Shirdi is a soulful retreat for faith and devotion."
  },
  {
    "title": "Nashik",
    "description": "Nashik, 210 km from Pune, is a city of temples, vineyards, and riverside ghats. The Trimbakeshwar Temple, one of the 12 Jyotirlingas, is a major spiritual attraction. Panchavati, Sita Gufa, and Ramkund connect it to the Ramayana. Sula Vineyards and wineries make it India’s wine capital. Nashik also hosts the Kumbh Mela every 12 years, attracting millions. It is a balanced mix of spirituality and leisure."
  },
  {
    "title": "Kolhapur",
    "description": "Kolhapur, about 230 km from Pune, is famous for the Mahalaxmi Temple, a Shakti Peetha of immense religious importance. Visitors also explore Rankala Lake, Panhala Fort, and Jyotiba Temple. Kolhapur is equally renowned for spicy Kolhapuri cuisine and traditional chappals. Its blend of devotion, culture, and shopping makes it a fulfilling trip. Festivals like Navratri and fairs attract large crowds. Kolhapur is a complete cultural experience."
  },
  {
    "title": "Satara (Kaas Plateau)",
    "description": "Satara, about 110 km from Pune, is famous for the Kaas Plateau, a UNESCO World Heritage Site. During monsoon, the plateau blooms with rare flowers, earning it the name ‘Valley of Flowers of Maharashtra.’ Sajjangad Fort and Thoseghar Waterfalls add to its charm. Trekkers and photographers love its natural beauty. The scenic landscapes are best enjoyed between August and October. Satara is a monsoon paradise for nature enthusiasts."
  },
  {
    "title": "Ajanta & Ellora Caves",
    "description": "Located near Aurangabad, around 250 km from Pune, the Ajanta and Ellora Caves are UNESCO World Heritage Sites. Ajanta features Buddhist frescoes and sculptures from the 2nd century BC, while Ellora showcases Hindu, Buddhist, and Jain rock-cut temples. The Kailasa Temple at Ellora is a monolithic masterpiece. These caves are a window into India’s ancient art and architecture. They are ideal for history buffs and cultural travelers."
  }
],


"services": [
    {
        "name": "Innova Car Rental",
        "description": "Rent a Toyota Innova in Pune for local or outstation travel with ease. Our Innova car rental service is ideal for families, business travelers, and group outings, offering spacious seating, expert chauffeurs, and competitive pricing for a hassle-free journey."
    },
    {
        "name": "Innova Car Rent per Day",
        "description": "Check our daily rental rates for Innova cars in Pune, perfect for city tours, day trips, or multi-day travel. With professional drivers and well-maintained vehicles, enjoy peace of mind with full-day rental flexibility and transparent billing."
    },
    {
        "name": "Innova Car Rental Near Me",
        "description": "Find nearby Innova rental services in Pune for quick and convenient bookings. Our GPS-enabled system connects you to trusted providers offering clean, comfortable Innovas with trained drivers for both local and long-distance travel."
    },
    {
        "name": "Innova Rental per km",
        "description": "Get transparent per kilometer pricing for Innova rentals in Pune. Ideal for outstation trips or long-distance city rides, our pricing is budget-friendly with no hidden charges, ensuring a smooth and economical travel experience."
    },
    {
        "name": "Innova Crysta Taxi",
        "description": "Book a luxurious Innova Crysta taxi for travel in and around Pune. With advanced features, plush interiors, and top-rated drivers, our Crysta taxis are the preferred choice for comfortable, reliable, and premium travel."
    },
    {
        "name": "Book Innova for Outstation",
        "description": "Easily book an Innova for your next outstation trip from Pune. Whether you're heading to a hill station or a pilgrimage, our spacious cabs and courteous drivers ensure you travel in complete comfort and convenience."
    },
    {
        "name": "Innova Crysta Rental Price",
        "description": "Explore competitive rental prices for Innova Crysta cabs in Pune. Our rates are tailored to fit various budgets and trip lengths, with options for per day or per km billing, making long journeys affordable and enjoyable."
    },
    {
        "name": "Innova Crysta Rental",
        "description": "Rent an Innova Crysta for local or long-distance trips in Pune. Our Crysta rentals include experienced chauffeurs, high-end features, and multiple booking plans, ideal for business tours, family vacations, or corporate travel."
    },
    {
        "name": "Toyota Innova Cabs",
        "description": "Travel with ease in Toyota Innova cabs available across Pune. Our fleet of Innovas is perfect for group travel, offering ample space, AC comfort, and reliable service for both short and long-distance rides."
    },
    {
        "name": "Innova SUV Cab Booking",
        "description": "Book an SUV Innova cab in Pune for a smooth and comfortable travel experience. With strong road presence, spacious seating, and great ride quality, our SUV cabs are perfect for hilly terrains, group outings, and family trips."
    },
    {
        "name": "Innova Long Trip Rental",
        "description": "Planning a long road trip from Pune? Rent an Innova for long-distance travel with spacious interiors, reliable performance, and professional drivers. Ideal for multi-day tours, pilgrimages, or sightseeing vacations."
    },
    {
        "name": "7 Seater Innova Booking Pune",
        "description": "Book 7-seater Innova cabs in Pune for group or family travel. Our vehicles offer generous legroom, luggage space, and comfort, making them ideal for airport transfers, city tours, and outstation journeys."
    },
    {
        "name": "Family Innova Cab",
        "description": "Choose our family-friendly Innova cab service in Pune for safe and convenient travel. Our drivers are courteous, the vehicles are child-safe and clean, and the entire ride is tailored for comfort and family enjoyment."
    },
    {
        "name": "Luxury Innova Hire Pune",
        "description": "Hire luxury Innovas in Pune for premium travel experiences. Ideal for VIP guests, executives, or special occasions, our luxury Innova fleet features high-end interiors, extra comfort, and reliable chauffeurs for smooth travel."
    }
],
"tableData": [
    ["Innova Car Rental", "Innova Car Rent per Day"],
    ["Innova Car Rental Near Me", "Innova Rental per km"],
    ["Innova Crysta Taxi", "Book Innova for Outstation"],
    ["Innova Crysta Rental Price", "Innova Crysta Rental"],
    ["Toyota Innova Cabs", "Innova SUV Cab Booking"],
    ["Innova Long Trip Rental", "7 Seater Innova Booking Pune"],
    ["Family Innova Cab", "Luxury Innova Hire Pune"]
],


"whychoose": [
    {
        "WhyChooseheading": "Spacious & Comfortable Innova Cabs for Every Occasion",
        "WhyChoosedescription": "Prince Cabs offers premium Innova cabs that are ideal for families, group travel, business trips, airport transfers, and outstation journeys. Whether you’re traveling within Pune or planning a long-distance road trip, our Innova vehicles provide unmatched comfort, ample legroom, reclining seats, and generous luggage space, ensuring a smooth and pleasant journey for all passengers."
    },
    {
        "WhyChooseheading": "Choose Between Innova & Innova Crysta Models",
        "WhyChoosedescription": "Our fleet includes both standard Toyota Innova and the more luxurious Innova Crysta variants. Whether you need a reliable 6-seater for everyday use or a 7-seater Crysta with plush interiors for executive travel, we provide the right option at the right price. Both models are air-conditioned, GPS-enabled, and maintained to deliver a premium ride experience."
    },
    {
        "WhyChooseheading": "Perfect for Local, Outstation, and Airport Travel",
        "WhyChoosedescription": "Innova cabs are ideal for all types of travel—whether it’s a quick city transfer, a Pune to Mumbai airport drop, or a multi-day trip to Goa, Mahabaleshwar, Shirdi, or Konkan. Prince Cabs provides customizable packages for one-way, round-trip, or full-day rental, offering complete flexibility as per your travel plans."
    },
    {
        "WhyChooseheading": "Professional Drivers with Highway & City Expertise",
        "WhyChoosedescription": "Our Innova cabs come with experienced and courteous drivers who are familiar with city routes, highways, and tourist destinations. They prioritize passenger safety, smooth driving, and timely service—whether you're navigating city traffic or cruising down long outstation routes."
    },
    {
        "WhyChooseheading": "Transparent Pricing with Per Km & Package Options",
        "WhyChoosedescription": "Prince Cabs offers fair and transparent pricing for Innova rentals with options to book on a per km basis (typically ₹16–₹20/km) or opt for fixed packages for common routes. All charges including driver allowance, tolls, and taxes are clearly shared before the ride—so you can travel worry-free without hidden costs."
    },
    {
        "WhyChooseheading": "Clean, Sanitized & Well-Maintained Vehicles",
        "WhyChoosedescription": "Your comfort and safety are our priority. Every Innova is thoroughly cleaned and sanitized before each trip. Regular servicing and inspections ensure top-notch mechanical performance, AC comfort, and hygiene throughout your journey."
    },
    {
        "WhyChooseheading": "Easy Booking & 24/7 Customer Support",
        "WhyChoosedescription": "Booking an Innova with Prince Cabs is simple—just call, message on WhatsApp, or book online. Our support team is available 24/7 to help you with quotes, custom plans, or urgent bookings, ensuring a smooth experience from the moment you enquire until the end of your ride."
    }
]
























    }

const faqData = [
    {
        question: 'Does Prince Cabs provide Innova cabs in Pune?',
        answer: 'Yes, Prince Cabs offers well-maintained Toyota Innova and Innova Crysta cabs in Pune for local, airport, and outstation travel.',
    },
    {
        question: 'What seating capacity does the Innova cab offer?',
        answer: 'Our Innova cabs can comfortably accommodate 6 to 7 passengers, making them perfect for families, small groups, and business travel.',
    },
    {
        question: 'What is the per km rate for Innova cabs?',
        answer: 'The starting per km rate for Innova is ₹18/km, and for Innova Crysta it’s ₹20/km. Final pricing depends on distance, route, and duration.',
    },
    {
        question: 'Are Prince Cabs’ Innova vehicles available for outstation trips?',
        answer: 'Absolutely! Innova and Innova Crysta are among the most preferred vehicles for outstation travel due to their comfort and space.',
    },
    {
        question: 'Can I book an Innova cab for airport transfers?',
        answer: 'Yes, Innova cabs are available for Pune Airport pickup and drop services, offering ample luggage space and a smooth travel experience.',
    },
    {
        question: 'Are your Innova cabs sanitized and driver-verified?',
        answer: 'Yes, all Innova vehicles are regularly sanitized, cleaned, and driven by background-verified, experienced chauffeurs.',
    },
    {
        question: 'How can I book an Innova cab with Prince Cabs?',
        answer: 'Booking is easy—just visit our website or call us with your travel details. We’ll confirm your booking instantly with transparent pricing.',
    },
];

const testimonials = [
    {
        name: "Mr. Rohan Salvi",
        position: "Corporate Traveler",
        text: "Booked an Innova Crysta with Prince Cabs for a Pune to Mumbai meeting. Very professional driver and smooth experience. Highly recommend!",
        image: "/img/testimonial/testimonial-thumb-innova-cabs-1.png",
    },
    {
        name: "Mrs. Neeta Desai",
        position: "Family Trip Organizer",
        text: "Prince Cabs provided a clean and spacious Innova for our family’s trip to Mahabaleshwar. Booking was easy and the ride was super comfortable.",
        image: "/img/testimonial/testimonial-thumb-innova-cabs-2.png",
    },
];


































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Cabs",
  "image": "https://princecab.com/assets/images/innova-cabs.jpg",
  "description": "Book Innova cabs with Prince Cabs for comfortable, spacious, and reliable rides. Perfect for family trips, outstation travel, and long-distance rentals with affordable pricing and luxury options.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "0",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/innova-cabs"
  }
};






    return (
        <div>
<Helmet>
  <title>Innova Cabs | Comfortable & Spacious Taxi Service | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers reliable Innova cab rentals for family trips, outstation travel, and long-distance rides. Book your Innova cab with us for affordable luxury and spacious comfort."
  />
  <meta
    name="keywords"
    content="Innova Car Rental, Innova Car Rent per Day, Innova Car Rental Near Me, Innova Rental per km, Innova Crysta Taxi, Book Innova for Outstation, Innova Crysta Rental Price, Innova Crysta Rental, Toyota Innova Cabs, Innova SUV Cab Booking, Innova Long Trip Rental, 7 Seater Innova Booking Pune, Family Innova Cab, Luxury Innova Hire Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/28.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Innovacabs;